import ReactApexChart from 'react-apexcharts';
import React, {useEffect, useState} from 'react';
import classes from './Chart.module.scss';
import Loader from "./Loader";

const Chart =  (props) => {
    const [series, setSeries] = useState([{
        name: props.title,
        data: props.data
    }]);
    const [options, setOptions] = useState({
        chart: {
            stacked: false,
            toolbar: {show: true},
            animations: {enabled: false},
            zoom: false,
            id: props.id + 1,
            group: props.group,
        },
        noData: {
            text: "Извините, данных для отображения нет",
            align: "center",
            verticalAlign: "center",
            offsetX: 0,
            offsetY: 0,
            style: {
                color: '#226a99',
                fontSize: "24px",
                fontFamily: "Arial, sans-serif"
            }
        },
        stroke: {
            colors: props.color,
            show: true,
            width: 1,
            curve: 'straight',
        },
        grid: {
            show: true,
            borderColor: "var(--color-light)",
            strokeDashArray: 10,
        },
        dataLabels: {
            enabled: false,
        },
        markers: {
            size: 0,
        },
        legend: {show: false},
        title: {
            text: `${props.title}, ${props.unit}`,
            align: 'left'
        },
        fill: {
            type: 'gradient',
            colors: props.color,
            gradient: {
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 0.9,
                opacityTo: 0,
            },
        },
        tooltip: {
            x: {
                format: 'yyyy.MM.dd HH:mm',
            },
            marker: {
                show: true,
            },
        },
        xaxis: {
            type: 'datetime',
            labels: {
                show: true,
                format: `yyyy.MM.dd HH:mm`,
                datetimeUTC: false,
            },
            tooltip: {enabled: false}
        },
        yaxis: {
            showForNullSeries: true,

        }
    });
    const updateChartData = async () => {
        const newSeries = [{
            name: props.title,
            data: props.data
        }];
        setSeries(newSeries);
    };
    useEffect(() => {
        updateChartData().then(null)
    }, [props])
    return (
        <div className={classes.wrapper} style={props.ui ? {display: 'block'} : {display: 'none'}}>
            {props.isFetch
                ?
                <ReactApexChart
                    options={options}
                    series={series}
                    type="area"
                    height={220}/>
                : <Loader/>
            }
        </div>
    );
}

export default Chart;